import type { FaireProductEntity } from "../../entity_types/product";

export const p_sgaaaufprg: FaireProductEntity = {
  token: "p_sgaaaufprg",
  type: "product",
  name: "You Are Made For This: Devotions To Uplift & Encourage Moms",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/acbbea7c30912b48515e609aadfb0fcce1386a68c8baa4e9bfae27c2571ec2ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/65f317c2aad7305f066bceafb4ab8f605de06882d9392156e96c77aa77ce4549.png",
    "https://cdn.faire.com/fastly/25c6ac63e3cab4102a83d341d2a6941e3b119cd5879e373a51158ca2cc49fe86.png",
    "https://cdn.faire.com/fastly/4998e3041f8edff9b67cf759ab483994627cbe7d1e0bdb4212958839cf77f87f.jpeg",
    "https://cdn.faire.com/fastly/6c5b285d54e68667b4c17ba2201939cbb57f789324f10e4c2db0fded33434787.jpeg",
    "https://cdn.faire.com/fastly/514dd73465065552ec603b17894d323ba1aebe76cd68398b3601f6fb5599e53c.png",
    "https://cdn.faire.com/fastly/d9e40975cc9adcdeb962e89c96317c0d9f7f96f081c8560f89e7457e38fd4d95.jpeg",
    "https://cdn.faire.com/fastly/29dc0f6a0266dab5befe3263607c8cd90dfd5224f9620ef0ea80939be2b36f8d.png",
    "https://cdn.faire.com/fastly/2a39c2c23fd6dccd2f1ef3f862f2954cb466df6e932f6f23acd3e64b75809d0b.jpeg",
    "https://cdn.faire.com/fastly/571732c1e05111e1821e494949e030300e788ab96bef2a5d5fc672aac5d26e69.png",
    "https://cdn.faire.com/fastly/aa74bbf900143cd1f9ceb9ff924132eac37e1fe61af48904c3c3ed863eaba868.png",
  ],
  priceDollars: 12.33,
  description:
    "Everyone needs a mother, but mothers don’t always feel needed, wanted, or confident in their role. Raising children is filled with ups, downs, and obligations, and while moms are centrally important to their family’s well-being, they can often neglect their own, which can lead to insecurity and self-doubt. This devotional is designed to empower and encourage busy mothers, reminding them of their value, God’s provision, and the divine purpose that is already being fulfilled in their lives, even when it feels like they’re living in chaos or stuck in the daily grind.\n\nDETAILS:\n• Author: Melissa Horvath - Owner, Designer of Sweet Water Decor\n• Publisher: DaySpring\n• Language: English\n• Hardcover: 208 Pages\n• Size: 5 x 7\"\n• Style No. BK003\n\nEncouragement, Motivational, Inspirational, Christian, Religious, Mother's Day, New Parents, Baby Shower, Mothers Day Gifts, Mothers Day decor",
  tags: [],
  msrpDollars: 20.55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:49.682Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
